import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Calendar,
  dateFnsLocalizer,
  momentLocalizer,
} from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import moment from "moment";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "rsuite/DateRangePicker/styles/index.css";
import { PrimeIcons } from "primereact/api";
import {
  DeleteAPICall,
  convertDateTimeCLSS,
  postAPICall,
  putAPICall,
  removeLeadingNumberAndDash,
  removeLeadingTextAndDash,
  setToastRef,
  showErrorToast,
  showSuccessToast,
  showToast,
} from "../Api/Api";
import { DateRangePicker } from "rsuite";
import { Toast } from "primereact/toast";
import PlaylistScheduleList from "../HomeScreenDetail/PlaylistScheduleList.jsx";
import { ContextMenu } from "primereact/contextmenu";
import "../HomeScreenHeader/Schedule/Schedule.css";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { IoIosCopy } from "react-icons/io";
import { format } from "date-fns";
import TvSelection from "./TvSelection.jsx";
import "./Style.css";
import DeleteOfTheMonthDialog from "./DeleteOfTheMonthDialog.jsx";
import GlobalPopup from "../GlobalComponents/GlobalPopup.jsx";
import { useLoader } from "../GlobalComponents/Loader.jsx";
import { Dialog } from "primereact/dialog";
const localizer = momentLocalizer(moment);
const DnDCalendar = withDragAndDrop(Calendar);
const views = ["week", "day", "month"];
const Scheduler = (props) => {
  const toast = useRef(null);
  const cm = useRef(null);
  let navigate = useNavigate();
  const scheduler = useRef(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [events, setEvents] = useState([]);
  const [scheduleHdrId, setScheduleHdrId] = useState("");
  const [CStartDate, setcopyStartDate] = useState();
  const [CEndDate, setcopyEndDate] = useState();
  const [AStartDate, setActiveStartDate] = useState(
    moment().startOf("weeks").toDate()
  );
  const [AEndDate, setActiveEndDate] = useState(
    moment().endOf("weeks").toDate()
  );
  const { showLoader, hideLoader } = useLoader();
  // const { showloader, hideloader } = useLoader();
  const [tvselectionPopup, setTVselectionPopup] = useState(false);
  const [ConfirmedCopyUS, setConfirmedCopyUS] = useState(false);
  const [ConfirmationUS, setConfirmationUS] = useState(false);
  const [visibleMediaMasterPopup, setVisibleMediaMasterPopup] = useState(false);
  const [error, setError] = useState(null);
  //new changes
  const [IsCopyOfTheWeekDialogVisible, setIsCopyOfTheWeekDialogVisible] =
    useState(false);
  const [confirmationData, setConfirmationData] = useState(null);
  const [IsDeleteDialogVisible, setIsDeleteDialogVisible] = useState(false);
  const [IsDelete, setIsDelete] = useState(false);
  const [DeletedselectedEvent, setDeletedSelectedEvent] = useState(null);
  const [IsDeleteOftheWeekDialogVisible, setIsDeleteOftheWeekDialogVisible] =
    useState(false);
  const [DeleteoftheweekData, setDeleteoftheweekData] = useState(false);
  const [DeleteOfthemonthDialog, setDeleteOfthemonthDialog] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  //MonthCopy
  const [isCopyOftheMonth, setisCopyOftheMonth] = useState(false);
  const [confirmCopyMonthAllData, setConfirmCopyMonthAllData] = useState(null);
  const [confrimSkipCopyAllData, setConfrimSkipCopyAllData] = useState(null);
  const [ChkValue, setChkValue] = useState(false);
  //Tvslection
  const [checkedModelList, setCheckedModelList] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setToastRef(toast.current);
    if (
      props?.ScheduleinfoSelectedRowValue.length != 0 ||
      props?.selectednewid
    ) {
      fetchScheduleData();
    }
  }, [props?.selectednewid]);
  const Schedulename = useMemo(() => {
    const text = props?.ScheduleinfoSelectedRowValue?.ScheduleName || "";
    return removeLeadingTextAndDash(text);
  }, [props?.ScheduleinfoSelectedRowValue?.ScheduleName]);
  const fetchScheduleData = async () => {
    showLoader();
    try {
      localStorage.removeItem("ScheduleHdrName");
      let stringconversion =
        props?.selectednewid !== "" ? props?.selectednewid.toString() : "";
      props.selectednewid ? setLoading(true) : setLoading(false);
      const requestBody = {
        ScheduleLibraryID:
          stringconversion || props?.ScheduleinfoSelectedRowValue?.id,
      };

      let response = await postAPICall(
        "api/Schedule/GetLoadSchedule",
        requestBody
      );
      if (response?.status === 200) {
        hideLoader();
        setLoading(false);
        // setEvents(response?.data);
        if (Array.isArray(response.data) && response.data.length > 0) {
          // Process events data
          const processedEvents = response.data
            .map((event) => {
              // Parse date string into components
              const startDateComponents = event.StartDate.split(/[-T:]/);
              const endDateComponents = event.EndDate.split(/[-T:]/);

              // Create Date objects using parsed components
              const start = new Date(
                startDateComponents[0], // year
                startDateComponents[1] - 1, // monthIndex (months are 0-indexed)
                startDateComponents[2], // day
                startDateComponents[3], // hours
                startDateComponents[4] // minutes
              );

              const end = new Date(
                endDateComponents[0], // year
                endDateComponents[1] - 1, // monthIndex (months are 0-indexed)
                endDateComponents[2], // day
                endDateComponents[3], // hours
                endDateComponents[4] // minutes
              );
              const subject = event.Subject;
              const Id = event.ID;
              // Check if startDate and endDate are valid Date objects before accessing getTime()
              const startDateValid =
                start instanceof Date && !isNaN(start.getTime());
              const endDateValid = end instanceof Date && !isNaN(end.getTime());

              if (startDateValid && endDateValid) {
                return {
                  ...event,
                  event_id: Id,
                  start: start,
                  end: end,
                  title: subject,
                };
              } else {
                // Handle case where StartDate or EndDate is not a valid Date object
                return null; // Skip this event
              }
            })
            ?.filter((event) => event !== null); // Filter out null events

          setEvents(processedEvents);
        } else {
          hideLoader();
          // Handle case where events data is empty
          setEvents([]);
        }
      } else {
        hideLoader();
        setEvents([]);
      }
    } catch (error) {
      hideLoader();
      setEvents([]); // Set events to empty array on error
    }
    hideLoader();
  };
  const UpdateAppoinment = async (e) => {
    showLoader();
    try {
      let startDate = e.start;
      let endDate = e.end;
      let eventsOverlap = checkEventOverlap(startDate, endDate, e.event.ID);
      if (!eventsOverlap) {
        // No overlap, proceed with updating the event
        let StartDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${startDate
          .getDate()
          .toString()
          .padStart(2, "0")} ${startDate
          .getHours()
          .toString()
          .padStart(2, "0")}:${startDate
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${startDate
          .getSeconds()
          .toString()
          .padStart(2, "0")}`;
        let EndDate = `${endDate.getFullYear()}-${(endDate.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${endDate
          .getDate()
          .toString()
          .padStart(2, "0")} ${endDate
          .getHours()
          .toString()
          .padStart(2, "0")}:${endDate
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${endDate
          .getSeconds()
          .toString()
          .padStart(2, "0")}`;
        const requestBody = {
          id: e.event.ID,
          startDate: StartDate,
          endDate: EndDate,
          subject: e.event.Subject,
        };

        // Make a PUT request to update the appointment place
        let response = await putAPICall(
          "api/Schedule/PutSchedule",
          requestBody
        );
        fetchScheduleData();
        hideLoader();
      } else {
        // Display overlap message to the user
        hideLoader();
        showErrorToast("error", "Overlaps with existing events!");
      }
    } catch (error) {
      setError(error.message);
    }
    hideLoader();
  };
  const checkEventOverlap = (startDate, endDate, eventIdToExclude) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    // Filter events to check for overlap excluding the event being dragged
    const overlappingEvents = events?.filter((event) => {
      const eventStart = new Date(event.StartDate);
      const eventEnd = new Date(event.EndDate);
      const excludeCurrentEvent = event.ID !== eventIdToExclude;

      // Check if the events overlap
      const overlaps =
        (start >= eventStart && start < eventEnd) ||
        (end > eventStart && end <= eventEnd) ||
        (start <= eventStart && end >= eventEnd);

      return excludeCurrentEvent && overlaps;
    });

    return overlappingEvents.length > 0;
  };

  const AddAppoinment = async (e) => {
    showLoader();
    // Assuming startDate is the variable containing your date string
    let startDate = e.start;
    let enddate = e.end;
    let StartDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${startDate
      .getDate()
      .toString()
      .padStart(2, "0")} ${startDate
      .getHours()
      .toString()
      .padStart(2, "0")}:${startDate
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${startDate.getSeconds().toString().padStart(2, "0")}`;
    let EndDate = `${enddate.getFullYear()}-${(enddate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${enddate
      .getDate()
      .toString()
      .padStart(2, "0")} ${enddate
      .getHours()
      .toString()
      .padStart(2, "0")}:${enddate
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${enddate.getSeconds().toString().padStart(2, "0")}`;
    let eventsOverlap = checkEventOverlap(startDate, enddate, e.ID);
    if (!eventsOverlap) {
      const requestBody = {
        startDate: StartDate,
        endDate: EndDate, // Adjusted end date without milliseconds
        subject: props.schedulename,
        scheduleHeaderID: props.scheduleHdrId,
        scheduleLibraryID: props.selectednewid,
      };
      setLoading(true);
      if (props.selectednewid != undefined && props.selectednewid != "") {
        let response = await postAPICall(
          "api/Schedule/PostSaveSchedule",
          requestBody
        );
        if (response?.status === 200) {
          setLoading(false);
          fetchScheduleData();
          hideLoader();
          showSuccessToast("Inserted Successfully!");
        }
      } else {
        hideLoader();
        showErrorToast("Please Select Library Name!");
      }
    } else {
      hideLoader();
      showErrorToast("Event overlaps with existing events!");
    }
    hideLoader();
  };

  const eventStyleGetter = (event, start, end, isSelected) => {
    // Customize event style here, including default resizing width
    const style = {
      backgroundColor: event.color,
      borderRadius: "5px",
      opacity: 0.8,
      color: "white",
      border: "1px solid #ccc",
      display: "block",
      cursor: "pointer",
      width: "100%", // Set width to "100%" to fill the calendar box size
    };
    return {
      style,
    };
  };
  // const eventStyleGetter = (event) => {
  //   return {
  //     title: event.Subject, // Ensure full title is set
  //     style: {
  //       backgroundColor: "#3174ad",
  //       color: "white",
  //       borderRadius: "5px",
  //       padding: "5px",
  //       border: "none",
  //       whiteSpace: "normal", // Ensures wrapping
  //       display:"flex",
  //       overflowWrap: "break-word",
  //     },
  //   };
  // };
  const items = [
    {
      label: "Open",
      icon: PrimeIcons.FOLDER_OPEN,
      command: () => {
        setVisibleMediaMasterPopup(true);
      },
    },
    {
      label: "Delete",
      icon: PrimeIcons.TRASH,
      command: async () => {
        handleDelete(selectedEvent);
      },
    },
    {
      label: "Copy Rest Of The Week",
      icon: PrimeIcons.COPY,
      command: async () => {
        handleCopyRestOfTheWeek(selectedEvent);
      },
    },
    {
      icon: PrimeIcons.TRASH,
      label: "Delete Of The Weeek",
      command: async () => {
        handleDeleteOfTheWeek(selectedEvent);
      },
    },
  ];
  //Single Delete Popup Open
  const handleDelete = (event) => {
    setDeletedSelectedEvent(event);
    setIsDeleteDialogVisible(true);
    // setIsDelete(true);
  };
  //Single Delete Yes
  const onDialogDeleteConfirm = async () => {
    showLoader();
    //setIsLoading(true);
    const requestBody = {
      id: DeletedselectedEvent.ID,
    };
    await DeleteAPICall("api/Schedule/DeleteSchedule", requestBody);
    fetchScheduleData();
    setIsDeleteDialogVisible(false);
    showSuccessToast("Deleted..");
    hideLoader();
    //setIsLoading(false);
  };
  const onDialogDeleteCancel = () => {
    setIsDeleteDialogVisible(false);
  };
  const handleCopyRestOfTheWeek = async (appointmentData) => {
    showLoader();
    let ActiveStartDate = appointmentData.StartDate;
    const currentDate = new Date(ActiveStartDate);
    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);
    nextDay.setHours(0, 0, 0, 0);

    const formattedDate = `${nextDay.getFullYear()}-${(nextDay.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${nextDay
      .getDate()
      .toString()
      .padStart(2, "0")} ${nextDay
      .getHours()
      .toString()
      .padStart(2, "0")}:${nextDay
      .getMinutes()
      .toString()
      .padStart(2, "0")}:${nextDay.getSeconds().toString().padStart(2, "0")}`;
    let copyStartDate = formattedDate;

    const endOfWeek = new Date(currentDate);
    endOfWeek.setDate(currentDate.getDate() + (7 - currentDate.getDay()));
    const formattedEndDate = endOfWeek.toISOString().split("T")[0];
    const timeString = "23:59:00";
    let copyEndDate = `${formattedEndDate} ${timeString}`;
    let SCHLibraryId = appointmentData.SCHLibraryId;
    let SchHdrId = appointmentData.ScheduleHdrId;
    let ScheduleID = appointmentData.ID;

    const requestBody = {
      copyStartDate: copyStartDate,
      copyEndDate: copyEndDate,
      ActiveStartDate: ActiveStartDate,
      ScheduleHeaderID: SchHdrId,
      ScheduleLibraryID: SCHLibraryId,
      ScheduleID: ScheduleID,
      Confirmation: false,
      ConfirmedCopy: false,
    };

    let responseExistScheduleCheck = await postAPICall(
      "api/Schedule/CopyRestOfTheWeekExist",
      requestBody
    );
    if (responseExistScheduleCheck?.data) {
      if (responseExistScheduleCheck.data.ConfirmedCopy) {
        const requestBody = {
          copyStartDate: copyStartDate,
          copyEndDate: copyEndDate,
          ActiveStartDate: ActiveStartDate,
          ScheduleHeaderID: SchHdrId,
          ScheduleLibraryID: SCHLibraryId,
          ScheduleID: ScheduleID,
          Confirmation: false,
          ConfirmedCopy: true,
        };
        let response = await postAPICall(
          "api/Schedule/CopyRestOfTheWeek",
          requestBody
        );
        fetchScheduleData();
        hideLoader();
        showSuccessToast("Copied Successfully..");
      } else {
        setConfirmationData({
          copyStartDate,
          copyEndDate,
          ActiveStartDate,
          ScheduleHeaderID: SchHdrId,
          ScheduleLibraryID: SCHLibraryId,
          ScheduleID: ScheduleID,
        });
        setIsCopyOfTheWeekDialogVisible(true);
      }
    }
    hideLoader();
  };
  //Copy Of the Week Yes
  const CopyOfTheWeekYes = async () => {
    showLoader();
    const requestBody = {
      ...confirmationData,
      Confirmation: true,
      ConfirmedCopy: false,
    };
    let response = await postAPICall(
      "api/Schedule/CopyRestOfTheWeek",
      requestBody
    );
    fetchScheduleData();
    hideLoader();
    showSuccessToast("Copied Successfully..");
    setIsCopyOfTheWeekDialogVisible(false);
    // setIsLoading(false);
  };
  //Copy Of the Week Cancel
  const CopyOfTheWeekCancel = async () => {
    showLoader();

    const requestBody = {
      ...confirmationData,
      Confirmation: false,
      ConfirmedCopy: false,
    };
    let response = await postAPICall(
      "api/Schedule/CopyRestOfTheWeek",
      requestBody
    );
    fetchScheduleData();
    hideLoader();
    showSuccessToast("Copied Successfully..");
    setIsCopyOfTheWeekDialogVisible(false);
    //setIsLoading(false);
  };

  const handleDeleteOfTheWeek = (appointmentData) => {
    setDeleteoftheweekData(appointmentData);
    setIsDeleteOftheWeekDialogVisible(true);
  };
  const confirmDelete = async () => {
    //setIsLoading(true); // Show loader
    showLoader();
    try {
      let ActiveStartDate = DeleteoftheweekData.StartDate;
      const currentEDate = new Date(ActiveStartDate);
      const endOfWeek = new Date(currentEDate);
      endOfWeek.setDate(currentEDate.getDate() + (7 - currentEDate.getDay()));
      const formattedEndDate = endOfWeek.toISOString().split("T")[0];

      let requestBody = {
        CopyStartDate: ActiveStartDate,
        CopyEndDate: formattedEndDate,
        ScheduleLibraryID: DeleteoftheweekData.SCHLibraryId,
      };

      let response = await DeleteAPICall(
        "api/Schedule/DeleteOfTheWeek",
        requestBody
      );
      fetchScheduleData();
      hideLoader();
      showSuccessToast("Deleted ...");
      setIsDeleteOftheWeekDialogVisible(false);
    } catch (error) {
      showErrorToast("An error occurred while deleting.");
    } finally {
      // setIsLoading(false); // Hide loader
    }
    hideLoader();
  };
  const hideDialogDeleteOftheWeek = () => {
    setIsDeleteOftheWeekDialogVisible(false);
  };
  //CopyOftheMonth hidden
  const hideDialogCopyOftheMonth = () => {
    setisCopyOftheMonth(false);
  };

  const ContexMenu = (e, eventData) => {
    e.preventDefault(); // Prevent the default context menu
    // const { id, title } = eventData; // Extract event ID and event name
    // handleDelete(eventData);
    setScheduleHdrId(eventData.ScheduleHdrId);
    localStorage.setItem("SchName", eventData.Subject);
    setSelectedEvent(eventData);
    // Perform further actions with the event ID and event name as needed
    cm.current.show(e); // Show the context menu
  };
  const handleCloseClick = () => {
    setVisibleMediaMasterPopup(false);
  };
  const onValueChanged = (e) => {
    if (e && e.length >= 0) {
      e[0].setHours(0);
      e[0].setMinutes(0);
      e[0].setSeconds(0);
      setcopyStartDate(e[0]);
      setcopyEndDate(e[1]);

      // CurrentScheduleStartandEndDate();
    }
  };
  function CurrentScheduleStartandEndDate() {
    // const currentDate = new Date();
    // // Calculate the start date of the current week (Sunday)
    // const startDate = new Date(currentDate);
    // startDate.setDate(startDate.getDate() - startDate.getDay());
    // // Calculate the end date of the current week (Saturday)
    // const endDate = new Date(currentDate);
    // endDate.setDate(endDate.getDate() + (6 - endDate.getDay()));
    // // Set the time to 00:00:00
    // startDate.setHours(0);
    // startDate.setMinutes(0);
    // startDate.setSeconds(0);
    // endDate.setHours(0);
    // endDate.setMinutes(0);
    // endDate.setSeconds(0);
    // // Do something with start and end dates
    // setActiveStartDate(startDate);
    // setActiveEndDate(endDate);
    // const currentDate = new Date();
    // // Calculate the start date of the current week (Sunday)
    // const startDate = new Date("2024-07-21");
    // startDate.setDate(startDate.getDate() - startDate.getDay());
    // // Calculate the end date of the current week (Saturday)
    // const endDate = new Date("2024-07-27");
    // endDate.setDate(endDate.getDate() + (6 - endDate.getDay()));
    // // Set the time to 00:00:00
    // startDate.setHours(0);
    // startDate.setMinutes(0);
    // startDate.setSeconds(0);
    // endDate.setHours(0);
    // endDate.setMinutes(0);
    // endDate.setSeconds(0);
    // // Do something with start and end dates
    // setActiveStartDate(startDate);
    // setActiveEndDate(endDate);
    // const schedulerInstance = scheduler.current.instance;
    // const startDate = schedulerInstance.getStartViewDate();
    // const endDate = schedulerInstance.getEndViewDate();
    // setActiveStartDate(startDate);
    // setActiveEndDate(endDate);
  }
  const CopySDatetoEData = async () => {
    showLoader();
    const today = new Date();
    //✅ Get the first day of the current week (Sunday)
    const firstDayinweek = new Date(
      today.setDate(today.getDate() - today.getDay())
    );
    //✅ Get the last day of the current week (Saturday)
    const lastDayinweek = new Date(
      today.setDate(today.getDate() - today.getDay() + 6)
    );
    // //Check Change Date or Not Change Date
    if (AStartDate !== undefined) {
      var sdate = AStartDate;
      var edate = AEndDate;
      sdate = AStartDate;
      edate = AEndDate;
    } else if (AStartDate === undefined) {
      var sdate = firstDayinweek;
      var edate = lastDayinweek;
      sdate = firstDayinweek;
      edate = lastDayinweek;
    }
    let stringconversion =
      props?.selectednewid !== "" ? props?.selectednewid.toString() : "";
    if (
      stringconversion !== "" &&
      CStartDate !== undefined &&
      CEndDate !== undefined
    ) {
      setTVselectionPopup(true);
      fetchScheduleData();
    } else {
      hideLoader();
      showErrorToast("Please Select Library and StartDate & EndDate");
    }
    hideLoader();
    // setCheckedModelList("");
  };
  const hidePopup = () => {
    setTVselectionPopup(false);
    setVisibleMediaMasterPopup(false);
  };
  const btnCopyClick = async (event) => {
    showLoader();
    const SelectedChkBoxes = checkedModelList?.length > 0;
    if (event) {
      let LibraryID = props?.selectednewid;
      let ActiveStartDate = convertDateTimeCLSS(AStartDate);
      let ActiveEndDate = convertDateTimeCLSS(AEndDate);
      let CopyStartDate = convertDateTimeCLSS(CStartDate);
      let CopyEndDate = convertDateTimeCLSS(CEndDate);
      // Filter appointments for the selected day and time
      const requestBody = {
        copyStartDate: CopyStartDate,
        copyEndDate: CopyEndDate,
        ActiveStartDate: ActiveStartDate,
        ActiveEndDate: ActiveEndDate,
        ScheduleLibraryID: LibraryID,
        Confirmation: ConfirmationUS,
        ConfirmedCopy: ConfirmedCopyUS,
        CheckAll: event.CheckAll,
        CheckTV1: event.CheckTV1,
        CheckTV2: event.CheckTV2,
        CheckTV3: event.CheckTV3,
        CheckTV4: event.CheckTV4,
        CheckTV5: event.CheckTV5,
        AccountGroupCode: localStorage.getItem("AccountGroupCode"),
      };
      //Check ExistData
      let responseExistScheduleCheck = await postAPICall(
        "api/Schedule/CopyScheduleAllorTVSelectionsExist",
        requestBody
      );

      if (responseExistScheduleCheck?.data)
        if (responseExistScheduleCheck?.data?.ConfirmedCopy) {
          // Direct copy Month...
          const requestBody = {
            CopyStartDate: CopyStartDate,
            CopyEndDate: CopyEndDate,
            ActiveStartDate: ActiveStartDate,
            ActiveEndDate: ActiveEndDate,
            ScheduleLibraryID: LibraryID,
            CheckAll: event.CheckAll,
            CheckTV1: event.CheckTV1,
            CheckTV2: event.CheckTV2,
            CheckTV3: event.CheckTV3,
            CheckTV4: event.CheckTV4,
            CheckTV5: event.CheckTV5,
            Confirmation: false,
            ConfirmedCopy: true,
            AccountGroupCode: localStorage.getItem("AccountGroupCode"),
          };

          let response = await postAPICall(
            "api/Schedule/CopyScheduleAllorTVSelections",
            requestBody
          );
          setTVselectionPopup(false);
          // setIsLoading(false);
          fetchScheduleData();
          hideLoader();
          showSuccessToast("Copied Successfully..");
          setCheckedModelList([]);
        } else {
          setTVselectionPopup(false);
          setisCopyOftheMonth(true);

          //Yes Copy Of the Month
          const requestBody = {
            CopyStartDate: CopyStartDate,
            CopyEndDate: CopyEndDate,
            ActiveStartDate: ActiveStartDate,
            ActiveEndDate: ActiveEndDate,
            ScheduleLibraryID: LibraryID,
            CheckAll: event.CheckAll,
            CheckTV1: event.CheckTV1,
            CheckTV2: event.CheckTV2,
            CheckTV3: event.CheckTV3,
            CheckTV4: event.CheckTV4,
            CheckTV5: event.CheckTV5,
            Confirmation: true,
            ConfirmedCopy: false,
            AccountGroupCode: localStorage.getItem("AccountGroupCode"),
          };
          setConfirmCopyMonthAllData(requestBody);
          //Cancel Copy and Skip of the Month
          const requestBodySkipMonth = {
            CopyStartDate: CopyStartDate,
            CopyEndDate: CopyEndDate,
            ActiveStartDate: ActiveStartDate,
            ActiveEndDate: ActiveEndDate,
            ScheduleLibraryID: LibraryID,
            CheckAll: event.CheckAll,
            CheckTV1: event.CheckTV1,
            CheckTV2: event.CheckTV2,
            CheckTV3: event.CheckTV3,
            CheckTV4: event.CheckTV4,
            CheckTV5: event.CheckTV5,
            Confirmation: false,
            ConfirmedCopy: false,
            AccountGroupCode: localStorage.getItem("AccountGroupCode"),
          };
          setConfrimSkipCopyAllData(requestBodySkipMonth);
        }
    } else {
      hideLoader();
      showErrorToast("Please Select the Tv!");
    }
    hideLoader();
  };
  const btnDeleteOftheMonth = (event) => {
    setDeleteOfthemonthDialog(true);
    setChkValue(event);
  };
  const handleConfirmDelete = async () => {
    showLoader();
    //setIsLoading(true);
    // Ensure event is properly defined or passed
    let LibraryID = props.selectednewid;
    let ActiveStartDate = convertDateTimeCLSS(AStartDate);
    let ActiveEndDate = convertDateTimeCLSS(AEndDate);

    let CopyStartDate = convertDateTimeCLSS(CStartDate);
    let CopyEndDate = convertDateTimeCLSS(CEndDate);
    // Filter appointments for the selected day and time

    const requestBody = {
      CopyStartDate: CopyStartDate,
      CopyEndDate: CopyEndDate,
      ActiveStartDate: ActiveStartDate,
      ActiveEndDate: ActiveEndDate,
      ScheduleLibraryID: LibraryID,
      // Ensure event properties are properly accessed or passed
      CheckAll: ChkValue.CheckAll,
      CheckTV1: ChkValue.CheckTV1,
      CheckTV2: ChkValue.CheckTV2,
      CheckTV3: ChkValue.CheckTV3,
      CheckTV4: ChkValue.CheckTV4,
      CheckTV5: ChkValue.CheckTV5,
      Confirmation: false,
      ConfirmedCopy: false,
      AccountGroupCode: localStorage.getItem("AccountGroupCode"),
    };
    let response = await postAPICall(
      "api/Schedule/DeleteScheduleAllorTVSelections",
      requestBody
    );
    showSuccessToast("Deleted...");
    fetchScheduleData();
    hideLoader();
    setDeleteOfthemonthDialog(false);
    setTVselectionPopup(false); // Close the dialog after confirmation
    // setIsLoading(false);
  };
  const closePopup = () => {
    setDeleteOfthemonthDialog(false);
  };
  const ContentTvSelection = (
    <div>
      <TvSelection
        btnCopyClick={btnCopyClick}
        btnDeleteOftheMonth={btnDeleteOftheMonth}
        NodeKeyLevel={props.newNodekeyLevel}
      />

      <DeleteOfTheMonthDialog
        visible={DeleteOfthemonthDialog}
        onConfirm={handleConfirmDelete}
        onHide={closePopup}
      />
    </div>
  );
  const handleOpenPlayListSchedulelist = () => {
    let ScheduleHdrId = selectedEvent?.ScheduleHdrId;
    let ScheduleHdrName = selectedEvent?.Schedulename;
    localStorage.setItem("SchHdrId", ScheduleHdrId);
    localStorage.setItem("ScheduleHdrName", ScheduleHdrName);
    navigate("/playlist");
  };

  //Copy Of The Month Yes
  const ConfirmCopyOftheMonth = async () => {
    //setIsLoading(true);
    showLoader();
    let response = await postAPICall(
      "api/Schedule/CopyScheduleAllorTVSelections",
      confirmCopyMonthAllData
    );
    fetchScheduleData();
    setisCopyOftheMonth(false);
    hideLoader();
    showSuccessToast("Copied Successfully..");
    // setIsLoading(false);
  };
  // sKIP AND Copy Of The Month  CANCEL
  const ConfirmSkipCopyOftheMonth = async () => {
    // setIsLoading(true);
    showLoader();
    let response = await postAPICall(
      "api/Schedule/CopyScheduleAllorTVSelections",
      confrimSkipCopyAllData
    );
    fetchScheduleData();
    setisCopyOftheMonth(false);
    hideLoader();
    showSuccessToast("Copied Successfully..");
    // setIsLoading(false);
  };
  const Handlenavigate = (date, view) => {
    const start = moment(date).startOf(view).toDate();
    const end = moment(date).endOf(view).toDate();

    setActiveStartDate(start);
    setActiveEndDate(end);
  };
  const formattedEvents = events.map((event) => ({
    ...event,
    title: event.Subject, // Set title to Subject only
  }));
  const OverideContent = (
    <>
      <h6>Do you want to override the appointment ...?</h6>
      <br />
      <div className="p-d-flex p-jc-end">
        <Button
          id="Dialog_Yes"
          label="Yes"
          icon="pi pi-check"
          onClick={CopyOfTheWeekYes}
          autoFocus
        />
        <Button
          id="Dialog_Cancel"
          label="Cancel"
          icon="pi pi-times"
          onClick={CopyOfTheWeekCancel}
          className="p-button-text"
        />
      </div>
    </>
  );
  const SingleDeleteConfirmation = (
    <>
      <h6>Do you want to delete this appointment?</h6>
      <br />
      <div className="p-d-flex p-jc-end">
        <Button
          id="Dialog_Yes"
          label="Yes"
          icon="pi pi-check"
          onClick={onDialogDeleteConfirm}
          autoFocus
        />
        <Button
          id="Dialog_Cancel"
          label="Cancel"
          icon="pi pi-times"
          onClick={onDialogDeleteCancel}
          className="p-button-text"
        />
      </div>
    </>
  );
  const DeleteOfTheWeekConfirmation = (
    <>
      <div className="confirmation-dialog-content">
        <h6>Are you sure you want to delete Of the Week ...?</h6>
        <br />
      </div>
      <div className="p-d-flex p-jc-end">
        <Button
          id="Dialog_Yes"
          label="Yes"
          icon="pi pi-check"
          onClick={confirmDelete}
          autoFocus
        />
        <Button
          icon="pi pi-times"
          id="Dialog_Cancel"
          label="No"
          onClick={hideDialogDeleteOftheWeek}
          className="p-button-text"
        />
      </div>
    </>
  );
  const CopyOfTheMonthConfirmation = (
    <>
      <h6>Do you want to override...?</h6>
      <br />
      <div className="p-d-flex p-jc-end">
        <Button
          id="Dialog_Yes"
          label="Yes"
          icon="pi pi-check"
          onClick={ConfirmCopyOftheMonth}
          autoFocus
        />
        <Button
          id="Dialog_Cancel"
          label="Cancel"
          icon="pi pi-times"
          onClick={ConfirmSkipCopyOftheMonth}
          className="p-button-text"
        />
      </div>
    </>
  );
  return (
    <>
      <Toast ref={toast} />
      <div id="ScheduleHeaderCard">
        <div>
          <label
            style={{
              fontFamily: "math",
              marginTop: "8px",
              marginRight: "auto",
              color: "grey",
              width: "fit-content",
            }}
          >
            Select Date
          </label>
        </div>

        <div>
          <DateRangePicker
            style={{
              fontFamily: "math",
              marginRight: "1px",
              alignItems: "start",
              alignContent: "start",
              width: "250px",
            }}
            showOneCalendar
            onChange={onValueChanged}
          />
        </div>
        <div>
          <i
            //className="pi pi-caret-right"
            style={{ marginTop: "10px", cursor: "pointer", fontSize: "20px" }}
            title="Copy"
            onClick={CopySDatetoEData}
          >
            <IoIosCopy />
          </i>
        </div>
        <div
          style={{
            fontFamily: "math",
            marginTop: "5px",
            marginLeft: "auto",
            color: "grey",
          }}
        >
          <b>
            <p
              hidden={
                props?.selectednewid || props?.ScheduleinfoSelectedRowValue
              }
            >
              Title
            </p>
            {props?.selectednewLibrayName || Schedulename}
          </b>
        </div>
      </div>

      <div style={{ height: "91%", width: "auto" }}>
        <DnDCalendar
          style={{ height: "84vh" }}
          ref={scheduler}
          localizer={localizer}
          events={formattedEvents}
          startAccessor="start"
          endAccessor="end"
          eventPropGetter={eventStyleGetter}
          views={views}
          defaultView={views[0]}
          onDropFromOutside={AddAppoinment}
          onEventDrop={UpdateAppoinment}
          resizable
          selectable
          onNavigate={Handlenavigate}
          showTimeslots={false}
          components={{
            eventWrapper: (props) => (
              <div onContextMenu={(e) => ContexMenu(e, props.event)}>
                {props.children}
              </div>
            ),
          }}
        />
        {/* )} */}
        <div className="card flex md:justify-content-center">
          <ContextMenu
            model={items}
            ref={cm}
            breakpoint="767px"
            className="custom-context-menu"
          />
        </div>
        {/* <GlobalPopup
          visible={visibleMediaMasterPopup}
          onHide={handleCloseClick}
          id="Playlist-popup"
          content={
            <>
              <Button
                style={{ borderRadius: "5px", padding: "15px" }}
                label="Go To Details"
                severity="primary"
                onClick={handleOpenPlayListSchedulelist}
              />
              <PlaylistScheduleList
                VisibleName={"ScheduleHDRName"}
                hidePlayicon={"hidePlayicon"}
                hideOpenbutton={"hideOpenbutton"}
                schnewid={scheduleHdrId}
              />
            </>
          }
          Popupheight={80}
          Popupwidth="550px"
          // Popupwidth={450}
          position={"top"}
        /> */}
        <Dialog
          className="Playlist-popup"
          header="Playlist Popup"
          visible={visibleMediaMasterPopup}
          style={{ width: "550px", height: "90vh" }}
          onHide={handleCloseClick}
          position="top"
        >
          <Button
            style={{ borderRadius: "5px", padding: "15px" }}
            label="Go To Details"
            severity="primary"
            onClick={handleOpenPlayListSchedulelist}
          />
          <PlaylistScheduleList
            VisibleName={"ScheduleHDRName"}
            hidePlayicon={"hidePlayicon"}
            hideOpenbutton={"hideOpenbutton"}
            schnewid={scheduleHdrId}
          />
        </Dialog>
        <GlobalPopup
          visible={tvselectionPopup}
          onHide={hidePopup}
          content={ContentTvSelection}
          dismissableMask={true}
          Popupheight={props.newNodekeyLevel == 7 ? 150 : 200}
          Popupwidth={100}
        />
      </div>
      <div>
        {/* Copy Rest of the Week" */}
        <GlobalPopup
          title={"Confirmation"}
          visible={IsCopyOfTheWeekDialogVisible}
          onHide={() => setIsCopyOfTheWeekDialogVisible(false)}
          content={OverideContent}
        />
      </div>
      {/* Single Delete */}
      <GlobalPopup
        title={"Confirmation"}
        visible={IsDeleteDialogVisible}
        onHide={onDialogDeleteCancel}
        content={SingleDeleteConfirmation}
      />

      {/* Delete Of the Week */}
      <GlobalPopup
        title={"Confirmation"}
        visible={IsDeleteOftheWeekDialogVisible}
        onHide={hideDialogDeleteOftheWeek}
        content={DeleteOfTheWeekConfirmation}
      />
      {/* CopyOf The Month */}
      <GlobalPopup
        title={"Confirmation"}
        visible={isCopyOftheMonth}
        onHide={hideDialogCopyOftheMonth}
        content={CopyOfTheMonthConfirmation}
      />
    </>
  );
};
export default Scheduler;
